import React from 'react';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import RegistryTable from '../shared/RegistryTable_RT';
// import ReportPowerOffModal from '../shared/ReportPowerOffModal';
import PeriodAndDisplaySelector from '../shared/PeriodAndDisplaySelector';

import * as api from '../../api/api';
import * as utils from '../../utils';


class ReportPage extends React.Component {
    constructor(props) {
        super(props);

        this.columns = [
            {
                Header: '_id',
                accessor: 'id',
            },
            {
                Header: '#',
                accessor: 'number',
            },
            {
                Header: 'Табло',
                accessor: 'display',
            },
            {
                Header: 'Остановочный пункт',
                accessor: 'checkpoint',
            },
            {
                Header: 'Период работы (ч.)',
                accessor: 'timeMust',
            },
            {
                Header: 'Фактически отработано (ч.)',
                accessor: 'timeFact',
            },
            {
                Header: 'Фактически отработано (%)',
                accessor: 'timeFactPercent',
            }
        ];

        // {
        //     Header: 'Отказы',
        //     accessor: 'failCount',
        // },
        // {
        //     Header: 'Выключения',
        //     accessor: 'shutdownCount',
        // }

        this.state = {
            report: [],
            displays: []
        }

        this.props.updateLoader({
            loaded: false,
            message: ""
        });

        this.getReport = this.getReport.bind(this);
        this.resetParameters = this.resetParameters.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
    }

    getReport() {

        let errors = [];

        if (!this.state.startDate || !this.state.endDate || !this.state.displays || this.state.displays.length === 0) {
            if (!this.state.startDate || !this.state.endDate) {
                errors.push(<li key={errors.length + 1} className="mb-2">Пожалуйста, выберите корректный период</li>);
            }
            if (!this.state.displays || this.state.displays.length === 0) {
                errors.push(<li key={errors.length + 1} className="mb-2">Пожалуйста, выберите табло</li>);
            }

            this.setState({
                errors: errors
            });

            return;
        }

        this.props.updateLoader({
            loaded: false
        });

        // const from = this.state.startDate.format("L");
        // const to = this.state.endDate.format("L");

        api.makeRequest(api.getReport({
            from: this.state.startDate,
            to: this.state.endDate,
            displays_id: this.state.displays

            // from: from,
            // to: to,
            // displays_id: (this.state.displays && this.state.displays.length > 0) ?
            //     this.state.displays.map((item) => {
            //         return item.value
            //     }) :
            //     []

        })).then(
            (response) => {
                if (response.data.data && response.data.data[0]) {
                    this.setState({
                        reportPeriodText: "Показаны данные за " + this.state.startDate + " - " + this.state.endDate,
                        report: response.data.data.map((item, i) => {
                            return {
                                id: item.id,
                                number: i + 1,
                                display: item.deviceId,
                                checkpoint: `${item.checkpoint.name} - ${item.checkpoint.description}`,
                                timeMust: item.liveMustBeHours,
                                timeFact: item.liveFactHours,
                                timeFactPercent: item.liveFactPercent
                            }

                            // failCount: item.failCount,
                            // shutdownCount: item.shutdowns.length,
                            // shutdowns: item.shutdowns.map((nowShutdown, j) => {

                            //     const dt = new Date(nowShutdown.dateTime);

                            //     return {
                            //         id: nowShutdown.id,
                            //         number: j + 1,
                            //         dateTime: utils.formatDate(dt),
                            //         user: nowShutdown.user,
                            //     }
                            // })
                        }),
                        errors: null
                    });
                }
                else {
                    this.setState({
                        report: [],
                        errors: null,
                        reportPeriodText: "Показаны данные за " + this.state.startDate + " - " + this.state.endDate,
                    });
                }

                this.props.updateLoader({
                    loaded: true
                });
            },
            (error) => {
                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при получении данных: " + error
                });
            }
        );
    }

    resetParameters(callback) {
        callback();

        this.setState({
            reportOptions: {
                displaysId: [],
                from: '',
                to: ''
            },
        });
    }

    handleRowClick(objectId) {
        //TODO: наверное, изменить на some()
        this.state.report.forEach(item => {
            if (item.id == objectId) {
                this.setState({
                    selectedObjectId: objectId
                });
                // reportPowerOffs: item.shutdowns
            }
        });
    }

    render() {
        return (
            // <div style={{ width: 80 + 'vw' }}>
            <div>
                <div className="card card-collapse">
                    <div className="card-header">
                        <h5>
                            <a data-toggle="collapse" href="#filterBlock">
                                Параметры отчёта
                            </a>
                        </h5>
                    </div>

                    <div className="collapse show" id="filterBlock">
                        <div className="card-body">

                            <PeriodAndDisplaySelector
                                onDatesChange={(startDate, endDate) => { this.setState({ startDate, endDate }) }}
                                onDisplaysChange={(displays) => { this.setState({ displays }) }}
                                updateLoader={this.props.updateLoader}
                                validateCallback={this.getReport}
                            />

                            {
                                this.state.errors &&
                                <div className="alert alert-warning p-2 mt-3" role="alert">
                                    Обнаружены ошибки:
                                    <ul className="mt-3">
                                        {this.state.errors}
                                    </ul>
                                </div>
                            }

                            <div className="d-flex justify-content-center mt-3">
                                <button className="btn btn-primary-custom" onClick={this.getReport}>
                                    Сформировать отчёт
                                </button>
                            </div>
                        </div>
                    </div>




                    {/* <div className="collapse show" id="filterBlock">
                        <div className="card-body">
                            <Formik
                                initialValues={this.state.reportOptions}
                                enableReinitialize={true}
                                validate={values => {
                                    let errors = {};

                                    if (!values.displaysId || values.displaysId.length == 0) {
                                        errors.displaysId = 'Пожалуйста, выберите устройства';
                                    };

                                    if (!values.from) {
                                        errors.from = 'Пожалуйста, заполните это поле';
                                    };

                                    if (!values.to) {
                                        errors.to = 'Пожалуйста, заполните это поле';
                                    };

                                    return errors;
                                }}
                                onSubmit={(values, { setSubmitting }) => {
                                    this.getReport(values);
                                }}
                            >
                                {({ isSubmitting,
                                    setFieldValue,
                                    values,
                                    resetForm
                                }) => (
                                        <Form>
                                            <div>
                                                <div className="form-group ml-3">
                                                    <label>Табло</label>
                                                    <Select
                                                        isMulti
                                                        options={this.state.displays}
                                                        value={values.displaysId}
                                                        onChange={(value) => setFieldValue("displaysId", value)}
                                                    />
                                                    <ErrorMessage className="form-error-message" name="displaysId" component="div" />
                                                </div>
                                                <div className="form-group ml-3">
                                                    <label>Начало отчётного периода</label>
                                                    <Field className="form-control" type="date" name="from" />
                                                    <ErrorMessage className="form-error-message" name="from" component="div" />
                                                </div>

                                                <div className="form-group ml-3">
                                                    <label>Конец отчётного периода</label>
                                                    <Field className="form-control" type="date" name="to" />
                                                    <ErrorMessage className="form-error-message" name="to" component="div" />
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-center mt-2">
                                                <button className="btn btn-primary-custom" type="submit">
                                                    Сформировать отчёт
                                            </button>
                                                <button className="btn btn-secondary ml-3" type="button" onClick={() => this.resetParameters(resetForm)}>
                                                    Сбросить параметры
                                            </button>
                                            </div>
                                        </Form>
                                    )}
                            </Formik>
                        </div>
                    </div> */}
                </div>

                <div className="card mt-5">
                    <div className="card-header">
                        <h5 className="mt-3 mb-3">Отчёт</h5>
                    </div>

                    <div className="card-body">

                        {
                            this.state.reportPeriodText &&
                            <div class="alert alert-info mt-3 mb-3" role="alert">
                                {this.state.reportPeriodText}
                            </div>
                        }

                        {/* <div className="d-flex justify-content-center list-group list-group-horizontal registry-actions registry-actions-one-item">
                            <a href="#reportPowerOffModal" className="list-group-item" data-toggle="modal" title="Показать выключения">
                                <FontAwesomeIcon icon="power-off" size="sm" color="#fff" />
                            </a>
                        </div> */}
                        {/* <a href="#reportPowerOffModal" className={this.state.selectedObjectId ? "list-group-item" : "list-group-item disabled"} data-toggle="modal" title="Показать выключения"> */}

                        <RegistryTable
                            columns={this.columns}
                            data={this.state.report}
                            showActions={false}
                            onRowClick={this.handleRowClick}
                            alwaysDisplayTable={false}
                        />

                        {/* <ReportPowerOffModal
                            data={this.state.reportPowerOffs}
                        /> */}
                    </div>
                </div>
            </div >
        );
    }
}

export default ReportPage;